import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

/**
 * Helper untuk mendapatkan Header yang dinamis.
 * Jika data berupa FormData, kita hapus 'Content-Type' agar browser 
 * yang menentukan boundary-nya (penting untuk upload file).
 */
const getAuthHeaders = (data) => {
  const token = getAuthToken();
  const headers = {
    'Authorization': `Bearer ${token}`,
  };

  // Jika data bukan FormData, gunakan default application/json
  if (!(data instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  
  return headers;
};

const PEMILIK_LAHAN_ENDPOINT = "/pemilik-lahan"; 

// =========================================================================
// SECTION: MASTER PEMILIK LAHAN (DATA PROFIL)
// =========================================================================

export const fetchPemilikLahans = async (params = {}) => { 
  try {
    const response = await axios.get(`${BASE_URL_BE}${PEMILIK_LAHAN_ENDPOINT}`, {
      params: params, // Axios akan otomatis mengubah object menjadi query string (?page=1&search=...)
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Pemilik Lahan:", error);
    throw error;
  }
};

export const createPemilikLahan = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}${PEMILIK_LAHAN_ENDPOINT}`, formData, {
      headers: getAuthHeaders(formData) // Header disesuaikan otomatis untuk FormData
    });
    return response.data;
  } catch (error) {
    console.error("Error creating Pemilik Lahan:", error);
    throw error;
  }
};

export const updatePemilikLahan = async (id_pemilik, formData) => {
  try {
    // Gunakan POST atau PUT sesuai dengan route di Backend (Update di Go biasanya PUT atau POST)
    const response = await axios.put(`${BASE_URL_BE}${PEMILIK_LAHAN_ENDPOINT}/${id_pemilik}`, formData, {
      headers: getAuthHeaders(formData)
    });
    return response.data;
  } catch (error) {
    console.error("Error updating Pemilik Lahan:", error);
    throw error;
  }
};

export const deletePemilikLahan = async (id_pemilik) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}${PEMILIK_LAHAN_ENDPOINT}/${id_pemilik}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting Pemilik Lahan:", error);
    throw error;
  }
};

// =========================================================================
// SECTION: DETAIL LAHAN (BIDANG TANAH / LUAS)
// =========================================================================

export const fetchLahanByPemilik = async (id_pemilik) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PEMILIK_LAHAN_ENDPOINT}/lahan/${id_pemilik}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching detail lahan:", error);
    throw error;
  }
};

export const createLahanDetail = async (payload) => {
  try {
    // Payload ini biasanya JSON murni, bukan FormData (tidak ada file)
    const response = await axios.post(`${BASE_URL_BE}${PEMILIK_LAHAN_ENDPOINT}/lahan`, payload, {
      headers: getAuthHeaders(payload)
    });
    return response.data;
  } catch (error) {
    console.error("Error creating detail lahan:", error);
    throw error;
  }
};

export const deleteLahanDetail = async (id_lahan) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}${PEMILIK_LAHAN_ENDPOINT}/lahan/${id_lahan}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting detail lahan:", error);
    throw error;
  }
};